import { render, staticRenderFns } from "./NewSupportTicketAttachment.vue?vue&type=template&id=4fc4ec97&"
import script from "./NewSupportTicketAttachment.vue?vue&type=script&lang=js&"
export * from "./NewSupportTicketAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports